import { getAutomatedStyleProp } from '@fourthwall/components';
import styled, { css } from 'styled-components';
export const Container = styled.button `
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};

  background: linear-gradient(#ec0095, #391fbd);
  background: radial-gradient(135.71% 135.71% at 28.85% 0%, #ec0095 0%, #391fbd 100%);

  border-radius: ${getAutomatedStyleProp('buttonCornerRadius')};

  white-space: nowrap;

  font-weight: 500;

  font-family: inherit;
  line-height: 24px;
  color: #fdfcfb;

  appearance: none !important; // NOTE: Required for Safari.

  ${({ size }) => size === 'large' &&
    css `
      padding: 12px 16px;
      font-size: 16px;
    `}

  ${({ size }) => size === 'medium' &&
    css `
      padding: 8px 14px;
      font-size: 16px;
    `}

  ${({ size }) => size === 'small' &&
    css `
      padding: 6px 10px;
      font-size: 14px;
    `}

  ${({ size }) => size === 'micro' &&
    css `
      padding: 4px 8px;
      font-size: 12px;
    `}

  &:hover {
    background: linear-gradient(#c7007d, #2e1999);
    background: radial-gradient(135.71% 135.71% at 28.85% 0%, #c7007d 0%, #2e1999 100%);
  }

  &:active,
  &:focus {
    background: linear-gradient(#c7007d, #2e1999);
    background: radial-gradient(135.71% 135.71% at 28.85% 0%, #c7007d 0%, #2e1999 100%);
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;
